import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ duration = 500, delay = 50 }) => {
    const { pathname } = useLocation();

    const smoothScrollToTop = (duration) => {
        const startPosition = window.pageYOffset;
        const startTime = performance.now();

        const easeInOutCubic = (t) => {
            return t < 0.5 
                ? 4 * t * t * t 
                : 1 - Math.pow(-2 * t + 2, 3) / 2;
        };

        const animation = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeProgress = easeInOutCubic(progress);
            
            window.scrollTo(0, startPosition * (1 - easeProgress));

            if (progress < 1) {
                requestAnimationFrame(animation);
            }
        };

        requestAnimationFrame(animation);
    };

    useEffect(() => {
        const scrollToTop = () => {
            smoothScrollToTop(duration);
        };

        if (delay > 0) {
            setTimeout(scrollToTop, delay);
        } else {
            scrollToTop();
        }
    }, [pathname, duration, delay]);

    return null;
};

const smoothScrollToTop = (duration = 1000) => {
    const startPosition = window.pageYOffset;
    const startTime = performance.now();

    const easeInOutCubic = (t) => {
        return t < 0.5 
            ? 4 * t * t * t 
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };

    const animation = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = easeInOutCubic(progress);
        
        window.scrollTo(0, startPosition * (1 - easeProgress));

        if (progress < 1) {
            requestAnimationFrame(animation);
        }
    };

    requestAnimationFrame(animation);
};

export {ScrollToTop, smoothScrollToTop};